import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { format, parseISO } from 'date-fns';
import { Trans } from 'next-i18next';
import { memo } from 'react';
import { Chips } from '../../../components/internal/DurationPicker/components/Chips/index.js';
import { Container } from '../../../components/internal/DurationPicker/components/Container.js';
import { Inputs } from '../../../components/internal/DurationPicker/components/Inputs/index.js';
import { LabelMediumBold, Stack } from '../../../primitives/index.js';
const DurationPickerComponent = ({
  range,
  durationOptions,
  duration,
  days,
  onChange,
  onClickDateRange,
  onDurationIsValid,
  activeInputType,
  setActiveInputType,
  ...restProps
}) => {
  const handleChipChange = item => {
    onDurationIsValid(true);
    setActiveInputType('chip');
    onChange({
      min: item.min,
      max: item.max
    });
  };
  const handleInputChange = item => {
    setActiveInputType('input');
    onChange(item);
  };
  const startDateParsed = parseISO(range.startDate || '');
  const endDateParsed = parseISO(range.endDate || '');
  const startDatePattern = startDateParsed.getFullYear() === endDateParsed.getFullYear() ? 'dd.MM.' : 'dd.MM.yy';
  const maxPossibleDuration = days && days < durationOptions.maxDuration ? days : durationOptions.maxDuration;
  const infoLabelInRange = _jsx(Trans, {
    i18nKey: "travelPeriodWidgetNew:headline",
    values: {
      from: format(startDateParsed, startDatePattern),
      to: format(endDateParsed, 'dd.MM.yy')
    },
    components: {
      span: _jsx(LabelMediumBold, {
        as: "span",
        color: "interactionSecondary",
        onClick: onClickDateRange
      })
    }
  });
  return _jsxs(Container, {
    ...restProps,
    children: [_jsxs(Stack, {
      children: [_jsx(LabelMediumBold, {
        children: infoLabelInRange
      }), _jsx(Chips, {
        maxDuration: maxPossibleDuration,
        selectedDays: days,
        duration: duration,
        items: durationOptions,
        onClick: handleChipChange,
        isDeactivated: activeInputType === 'input'
      })]
    }), _jsx(Stack, {
      children: _jsx(Inputs, {
        duration: duration,
        maxDuration: maxPossibleDuration,
        onChange: handleInputChange,
        setDisable: setActiveInputType,
        onDurationIsValid: onDurationIsValid,
        isActivated: activeInputType === 'input'
      })
    })]
  });
};
export const DurationPicker = /*#__PURE__*/_styled(memo(DurationPickerComponent), process.env.NODE_ENV === "production" ? {
  target: "etw5dix0"
} : {
  target: "etw5dix0",
  label: "DurationPicker"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");